
import 'react-toastify/dist/ReactToastify.css'
import './styles/main.sass'
import './styles/forms.sass'

import ReactDOM from 'react-dom/client'
import App from './components/layout/App'

ReactDOM.createRoot(document.getElementById('root')).render(
	// <React.StrictMode>
		<App />
	// </React.StrictMode>
)